import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ExportToCsvService } from 'src/app/core/services/export-to-csv.service';
import { ProjectApiService } from 'src/app/core/services/project-api.service';
import { ProjectInfo } from 'src/app/core/types';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { ImportExportService } from '../../core/services/import-export.service';
import { take } from 'rxjs/operators';


@Component({
    selector: 'gl-export-csv',
    templateUrl: './export-csv.component.html',
    styleUrls: ['./export-csv.component.scss'],
    standalone: false
})
export class ExportCsvComponent {
  public form: UntypedFormGroup;

  constructor(
    private modalRef: ModalOverlayRef,
    private projectApiService: ProjectApiService,
    private exportToCsv: ExportToCsvService,
    private importExportService: ImportExportService
  ) {
    this.modalRef.backgroundClicked();
    this.form = this.generateForm();
  }

  public close() {
    this.modalRef.close();
  }

  public export(): void {
    if (this.form.valid) {
      this.importExportService
        .exportProject(
          this.form.get('separator').value as 'comma' | 'semicolon',
          'csv'
        )
        .pipe(take(1))
        .subscribe((): void => {
          this.close();
        });
    }
  }

  public exportCSV(): void {
    if (this.form.valid) {
      this.projectApiService
        .getProjectInfo()
        .pipe(take(1))
        .subscribe((project: ProjectInfo) => {
          const separator = this.form.get('separator').value as 'comma' | 'semicolon';
          this.exportToCsv.createCsv(project, separator);
          this.close();
        });
    }
  }

  private generateForm(): UntypedFormGroup {
    return new UntypedFormGroup({
      separator: new UntypedFormControl('comma', [Validators.required]),
    });
  }
}
